export default __webpack_public_path__ + "static/IN-8015_4-2mm_lense_night_softwareWDR-9f6c09ae4cbd58515e45e15971ac0088.webp";